module.exports = __webpack_public_path__ + "assets/media/purple-arrow.ee35fde4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/OnboardingBotPreview/purple-arrow.svg
// module id = 3150
// module chunks = 0